import * as types from "./ai_actionTypes";
// import * as HeaderAuthentication from '../HeaderAuthentication'
import { aiBaseUrl, baseURL } from "../../BaseURL";
import { loadCreditsData } from "../action";
import { toast } from "react-toastify";

const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));

export const getAisearchedContacts = (AisearchedContacts) => ({
    type: types.get_AI_Contact_Data,
    payload: AisearchedContacts,
});
export const updateAisearchedContacts = (AisearchedContacts) => ({
    type: types.get_AI_Contact_Data_Update,
    payload: AisearchedContacts,
});
export const getViewedContacts = (viewedContacts) => ({
    type: types.get_Viedwed_Contact_Data,
    payload: viewedContacts,
});

export const loadApolloCount = (requestOption, resultype) => {
    return function (dispatch) {
        return fetch(`${aiBaseUrl}ai/ai-search`, requestOption)
            .then((resp) => resp.json())
            .then((resp) => {
                return resp
            })
            .catch((err) => { console.log(err) });
    }
};  

export const loadApolloCount1 = (requestOption, resultype) => {
    return function (dispatch) {
        return fetch(`${aiBaseUrl}ai/manual-search`, requestOption)
            .then((resp) => resp.json())
            .then((resp) => {
                return resp
            })
            .catch((err) => { console.log(err) });
    }
}; 



// region apicall for enrich data
export const loadEnrichData = (requestOption) => {
    return function (dispatch) {
        return fetch(`${aiBaseUrl}ai/enrich_data`, requestOption)
            .then((resp) => resp.json())
            .then((resp) => {
                const insertData = {
                    user_id: parseInt(signInDetails[0].id),
                    user_name: signInDetails[0].name,
                    sbn_id: signInDetails[0].sbn_id,
                    list_name: "Default",
                    enrichData: resp[0]
                };

                const requestOption = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(insertData),
                };
                dispatch(loadInsertData(requestOption))
                return resp
            })
            .catch((err) => { console.log(err) });
    }
}
// endregion


// region load get phone number
export const loadGetPhone = (requestOption) => {
    return function (dispatch) {
        return fetch(`${aiBaseUrl}ai/get-phone`, requestOption)
            .then((resp) => resp.json())
            .then((resp) => {
                const insertData = {
                    user_id: parseInt(signInDetails[0].id),
                    user_name: signInDetails[0].name,
                    sbn_id: signInDetails[0].sbn_id,
                    list_name: "Default",
                    enrichData: resp[0]
                };

                const requestOption = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(insertData),
                };
                dispatch(loadInsertData(requestOption))
                return resp
            })
            .catch((err) => { console.log(err) });
    }
}
// endregion

// region get phone from webhook
export const webHookGetPhone = (requestOption) => {
    return function (dispatch) {
        return fetch(`${aiBaseUrl}ai/phone-result`, requestOption)
            .then((resp) => resp.json())
            .then((resp) => {
                // if (resp.success === true) {
                // dispatch(loadInsertData(requestOption))
                dispatch(loadCreditsData(signInDetails[0]?.sbn_id, signInDetails[0]?.id));
                return resp
                // } else {
                // dispatch(webHookGetPhone(requestOption))
                // }
            })
            .catch((err) => { console.log(err) });
    }
}
// endregion

// region unlock bulk phone number
// export const unlockBulkPhone = (payload) => {
//     return function (dispatch) {
//         return fetch(`${aiBaseUrl}ai/bulk-phone-unlock`, payload)
//             .then((resp) => resp.json())
//             .then((resp) => {
//                 // const data = resp.data;
//                 // dispatch(getViewedContacts(data))
//                 return resp
//             })
//             .catch((err) => { console.log(err) });
//     }
// }
export const unlockBulkPhone = (payload) => {
    return async function () {
        try {
            const response = await fetch(
                `${aiBaseUrl}ai/bulk-phone-unlock`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                }
            );

            return await response.json();
        } catch (err) {
            console.log(err);
            return {
                success: false
            };
        }
    };
};
// endregion

// region inset bulk phone data
export const insertBulkPhones = (requestOption) => {
    return function (dispatch) {
        return fetch(`${aiBaseUrl}ai/get-insert-unlocked-phones`, requestOption)
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(loadCreditsData(signInDetails[0]?.sbn_id, signInDetails[0]?.id));
                return resp
            })
            .catch((err) => { console.log(err) });
    }
}
// endregion

// region apicall for viewed ids
export const loadViewedIds = () => {
    return function (dispatch) {
        return fetch(`${baseURL}/view_contacts/get_viewed_ids?user_id=${parseInt(signInDetails[0].id)}&sbn_id=${signInDetails[0].sbn_id}&role=${signInDetails[0].role}&list_name=`)
            .then((resp) => resp.json())
            .then((resp) => {
                const data = resp.data;
                dispatch(getViewedContacts(data))
                return data
            })
            .catch((err) => { console.log(err) });
    }
}
// endregion

// region insert enriched data to oracle
export const loadInsertData = (requestOption) => {
    return function (dispatch) {
        return fetch(`${aiBaseUrl}ai/enrich_data_insert`, requestOption)
            .then((resp) => resp.json())
            .then((resp) => {
                // const data = resp.data;
                // dispatch(getViewedContacts(data))
                dispatch(loadCreditsData(signInDetails[0]?.sbn_id, signInDetails[0]?.id));
                console.log(resp)
                return resp
            })
            .catch((err) => { console.log(err) });
    }
}
// endregion

// region save recent search data
export const postRecentSearchQuery = (requestOption) => {
    return function (dispatch) {
        return fetch(`${baseURL}/contact_search/add_recent_search`, requestOption)
            .then((resp) => resp.json())
            .then((resp) => {
                console.log(resp)
                return resp
            })
            .catch((err) => { console.log(err) });
    }
}



// endregion

// region api call to create list 
export const loadCreateListAi = (
    postRequest,
    fetchSearchContact,
    setListStatus
) => {
    return function (dispatch) {
        return fetch(`${baseURL}/lists/create_list_apollo`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success_code === 100) {
                    dispatch(loadCreditsData(signInDetails[0]?.sbn_id, signInDetails[0]?.id));
                    setListStatus(false)
                    // fetchSearchContact()
                    return resp
                } else {
                    toast.error(resp.message);
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
// endregion